var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('card-header',{attrs:{"title":_vm.component.title,"icon":"fa-dot-circle"}}),_c('card-body',[_c('render-component',{staticClass:"component-content",attrs:{"component":_vm.component}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }